import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Pages
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import StartupsPage from "@/pages/StartupsPage";
import EventsPage from "@/pages/EventsPage";
import AdvisorsPage from "@/pages/AdvisorsPage";
import AdvisorsBookPage from "@/pages/AdvisorsBookPage";
import StartupLoginPage from "@/pages/StartupLoginPage";
import RegisterStartupPage from "@/pages/RegisterStartupPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboard from "@/pages/AdminDashboard";

// Layout
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import QueryButton from "@/components/QueryButton";

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <Routes>
          {/* Admin Routes - No Navbar/Footer */}
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin/*" element={<AdminDashboard />} />
          
          {/* Startup Login - No Navbar/Footer */}
          <Route path="/advisors/login" element={<StartupLoginPage />} />
          
          {/* Public Routes with Navbar/Footer */}
          <Route path="/*" element={
            <>
              <Navbar />
              <main className="flex-1">
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/startups" element={<StartupsPage />} />
                  <Route path="/events" element={<EventsPage />} />
                  <Route path="/advisors" element={<AdvisorsPage />} />
                  <Route path="/advisors/book" element={<AdvisorsBookPage />} />
                  <Route path="/register" element={<RegisterStartupPage />} />
                </Routes>
              </main>
              <Footer />
              <QueryButton />
            </>
          } />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
